var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPulse = function SvgPulse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.0024H3.5C3.87844 11.0024 4.22446 10.7887 4.394 10.4504L5.187 8.87536L6.53 14.2434C6.64017 14.6848 7.03444 14.9962 7.48939 15.0012C7.94434 15.0061 8.34528 14.7033 8.465 14.2644L10.524 6.72936L11.538 10.2774C11.6608 10.7067 12.0534 11.0026 12.5 11.0024H15C15.5523 11.0024 16 10.5546 16 10.0024C16 9.45008 15.5523 9.00236 15 9.00236H13.256L11.462 2.72636C11.3391 2.2943 10.9431 1.99722 10.4939 2.00002C10.0447 2.00282 9.65253 2.3048 9.535 2.73836L7.544 10.0504L6.47 5.75736C6.36703 5.35234 6.02304 5.05406 5.60752 5.00947C5.19199 4.96489 4.79256 5.1834 4.606 5.55736L2.88 9.00236H1C0.447715 9.00236 0 9.45008 0 10.0024C0 10.5546 0.447715 11.0024 1 11.0024Z",
    fill: "currentColor"
  })));
};
export default SvgPulse;